import { createStore } from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import coupon from './modules/coupon'
import curriculum from './modules/curriculum'
import product from './modules/product'
import program from './modules/program'
import project from './modules/project'
import event from './modules/event'
import partner from './modules/partner'
import blogs from './modules/blogs'
import license from './modules/license'
import release from './modules/release'
import notification from './modules/notification'
import community from './modules/community'
import serviceRequest from './modules/serviceRequest'
import internalIssue from './modules/internalIssue'
import physicalEvent from './modules/physicalEvent'
import taskSystem from './modules/taskSystem'
import adminManagement from './modules/adminManagement'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
  },
  actions: {},
  modules: {
    auth,
    user,
    curriculum,
    product,
    program,
    project,
    event,
    partner,
    blogs,
    license,
    release,
    notification,
    community,
    serviceRequest,
    coupon,
    internalIssue,
    physicalEvent,
    taskSystem,
    adminManagement
  },
})
